import { render, staticRenderFns } from "./ChatAssistant.vue?vue&type=template&id=220a04cf&scoped=true"
import script from "./ChatAssistant.vue?vue&type=script&lang=js"
export * from "./ChatAssistant.vue?vue&type=script&lang=js"
import style0 from "./ChatAssistant.vue?vue&type=style&index=0&id=220a04cf&prod&lang=scss&scoped=true"
import style1 from "./ChatAssistant.vue?vue&type=style&index=1&id=220a04cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220a04cf",
  null
  
)

export default component.exports